import BaseService from "./BaseService";

export default class ProuniService extends BaseService {

  constructor(self) {
    super(self);
  }

  ConsultarProuni(parameters) {
    return this.ExecutaFetch("/api/Prouni/ConsultarProuni", "POST", parameters);
  }
}